import { render, staticRenderFns } from "./flockUploaded.vue?vue&type=template&id=22104c59&scoped=true&"
import script from "./flockUploaded.vue?vue&type=script&lang=js&"
export * from "./flockUploaded.vue?vue&type=script&lang=js&"
import style1 from "./flockUploaded.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22104c59",
  null
  
)

export default component.exports